export const formatCurrency = (number) => {
    return new Intl.NumberFormat("en-UG", {
      style: "currency",
      currency: "UGX",
    }).format(number);
  };

  /** Compact currency for tight spaces — e.g. 2500000 → "2.5M", 15000 → "15K", 800 → "800" */
  export const formatCompactCurrency = (number) => {
    const n = Math.abs(Number(number) || 0);
    const sign = number < 0 ? '-' : '';
    if (n >= 1_000_000) {
      const val = n / 1_000_000;
      return `${sign}${val % 1 === 0 ? val : val.toFixed(1)}M`;
    }
    if (n >= 1_000) {
      const val = n / 1_000;
      return `${sign}${val % 1 === 0 ? val : val.toFixed(1)}K`;
    }
    return `${sign}${Math.round(n)}`;
  };